import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  declare textValue: string
  declare readonly hasTextValue: boolean

  static values = {
    text: String
  }

  displayAlert({ currentTarget }: { currentTarget: HTMLAnchorElement | null }) {
    if (!currentTarget || !this.hasTextValue) { return }

    window.alert(this.textValue);
  }
}
